
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/watercon-solution",
      function () {
        return require("private-next-pages/watercon-solution.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/watercon-solution"])
      });
    }
  